module.exports = __webpack_public_path__ + "assets/img/20_447_big.360b47fe.jpg";